<!--
/*******************************************************************************
*@ 컴포넌트명   : PersonalInfoPopup.vue
*@ 컴포넌트설명 : 개인정보수집 동의 팝업
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!-- 개인정보수집 안내 -->
    <modal-pop :opened.sync="isPopupOpen" :modalHeader="true" :modalFooter="true" :btnClose="false" title="FIDO-0077">
      <template #content>
        <div class>
          <p>
            {{ /*은행 거래를 위해서는 개인정보수집 동의가 필요합니다.*/ $t("FIDO-0078") }}
            <u class="highlight" @click="fileDown()">{{ /*전문보기*/ $t("FIDO-0079") }}</u>
          </p>
          <br />
          <dl class="dlist dlist-item--type4 nomargin text-black">
            <dt>{{ /*처리 목적*/ $t("FIDO-0080") }}</dt>
            <dd v-html="$t('FIDO-0081')"></dd>
            <dt>{{ /*개인정보 유형*/ $t("FIDO-0082") }}</dt>
            <dd>{{ /*민감정보를 포함한 개인정보(이름, 생년월일, 생체정보 등)*/ $t("FIDO-0083") }}</dd>
            <dt>{{ /*처리 방식*/ $t("FIDO-0084") }}</dt>
            <dd>{{ /*개인정보보호법에 의한 처리*/ $t("FIDO-0085") }}</dd>
            <dt>{{ /*관련 기관*/ $t("FIDO-0086") }}</dt>
            <dd>{{ /*은행 및 제휴사*/ $t("FIDO-0087") }}</dd>
            <dt>{{ /*보유 기간*/ $t("FIDO-0088") }}</dt>
            <dd>{{ /*거래 종료일까지*/ $t("FIDO-0089") }}</dd>
            <dt>{{ /*예상치 못한 결과 및 손해*/ $t("FIDO-0090") }}</dt>
            <dd>{{ /*고객정보 유출로 인해 신원도용이나 사기가 발생할 수 있으며, 은행은 피해 최소화를 위해 즉각 조치를 취함.*/ $t("FIDO-0091") }}</dd>
          </dl>
          <br />
          <p>{{ /*위 내용에 동의하십니까?*/ $t("FIDO-0092") }}</p>
        </div>
      </template>
      <template #footer>
        <button
          class="btn bottom negative"
          @click="
            () => {
              isNoPopupOpen = true;
            }
          "
        >
          <!-- 아니오 -->
          {{ $t("FIDO-0093") }}
        </button>
        <button
          class="btn bottom positive"
          @click="
            () => {
              RBF060AB61Call();
            }
          "
        >
          <!-- 예, 동의합니다 -->
          {{ $t("FIDO-0094") }}
        </button>
      </template>
    </modal-pop>
    <modal-pop :opened.sync="isNoPopupOpen" :modalHeader="true" :modalFooter="true" class="modal">
      <template #content>
        <div>{{ /*은행 거래를 위해서는 개인정보수집 동의가 필수입니다.*/ $t("FIDO-0095") }}</div>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="
            () => {
              isNoPopupOpen = false;
            }
          "
        >
          {{ /*확인*/ $t("FIDO-0096") }}
        </button>
      </template>
    </modal-pop>
  </article>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
export default {
  props: ["opened"],
  components: {},
  mounted() {
    this.isNoPopupOpen = false;
  },
  created() {},
  data() {
    return {
      isNoPopupOpen: false,
    };
  },
  computed: {
    ...mapFields(["sessionInfo"]),
    ...mapGetters("native", ["getNativeAll"]),
    ...mapGetters(["isLvbdInfoRegiMandanCustYn", "isLvbdInfoRegiYn", "isPersonalUser"]),
    isPopupOpen: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    fileDown() {
      let fileName = "KB_Kookmin_Bank_Data_Privacy_Consent_Letter.pdf";
      fileName = fileName.replace(/\s/gi, "%20");
      const filePath = this.$fildDown({ FilePathName: "/ASIS/terms", PsyclFileName: fileName, LogicFileName: fileName });
      this.$log.info("fileName>>>>", fileName);
      this.$log.info("filePath>>>>", filePath.path);
      if (process.env.VUE_APP_API_CALL != "local") {
        switch (this.getNativeAll.smphMchtlDstcd) {
          case this.$config.OS_ANDROID:
            this.$bridge.fileDownload(location.origin + filePath.path);
            break;
          case this.$config.OS_IOS:
            this.$bridge.goURL(location.origin + filePath.path);
            break;
        }
      } else {
        this.$log.info(location.origin + filePath.path);
        return;
      }
    },
    RBF060AB61Call() {
      let params = {
        cnsntYn: "1",
      };
      this.$post("/auth/fido/certn/PersonalInfoCollection", params, this.RBF060AB61Suc);
    },
    RBF060AB61Suc() {
      this.$set(this.sessionInfo.userInfo, "ppsnInfoGathrCnsntYn", "1");
      if (this.isPersonalUser) {
        if (this.isLvbdInfoRegiMandanCustYn && !this.isLvbdInfoRegiYn) {
          this.$router.push({ name: "createEkyc" });
        }
      } else {
        if (!this.isLvbdInfoRegiYn) {
          this.$router.push({ name: "createEkyc" });
        }
      }

      this.isPopupOpen = false;
    },
  },
};
</script>
